import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "./LandingPage";
import { AuthProvider } from "./admin/AuthContext";
import ProtectedRoute from "./admin/ProtectedRoute";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import LeadsDashboard from "./admin/LeadsDashboard";
import LeadDetail from "./admin/LeadDetail";
import TeamManagement from "./admin/TeamManagement";

function App() {
  // Remove Emergent badge on mount
  React.useEffect(() => {
    const removeBadge = () => {
      const selectors = [
        '[data-emergent-badge]',
        '.emergent-badge',
        'a[href*="emergent.sh"]',
        'a[href*="emergent.ai"]',
        '#emergent-badge',
        '.made-with-emergent'
      ];

      selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          el.style.display = 'none';
          el.remove();
        });
      });

      document.querySelectorAll('div, a, span').forEach(el => {
        if (el.textContent && el.textContent.includes('Made with Emergent')) {
          el.style.display = 'none';
          el.remove();
        }
      });
    };

    removeBadge();
    setTimeout(removeBadge, 1000);
    setTimeout(removeBadge, 3000);

    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return (
    <AuthProvider>
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: { background: '#18181b', border: '1px solid #27272a', color: '#fff' }
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<LeadsDashboard />} />
            <Route path="leads/:id" element={<LeadDetail />} />
            <Route
              path="team"
              element={
                <ProtectedRoute requireAdmin>
                  <TeamManagement />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
